import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Table, ButtonGroup, Glyphicon } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

class GroepenOverzicht extends Component {
    constructor() {
        super();
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.getKennis = this.getKennis.bind(this)
        this.state = {
            groups: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: '/api/companies/groups', // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `api/groups/${id}/group`
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.print(`DELETE ${FETCH_URL_DELETE}`)
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                this.getKennis(this.state.currentFetchUrl) // Update the companies list
            })
        }
    }
    handlePaginationClick(e) {
        const FETCH_URL3 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL3 })
        this.getKennis(FETCH_URL3)
    }
    getKennis(fetchUrl) {
        var that = this;
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {

            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(data => {
            let comps = data.groups.map(function (item, index) {
                return <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>
                        <ButtonGroup>
                            <LinkContainer to={"/admin/leden/groepen/bewerken/" + item.id}>
                                <Button bsSize="xsmall" className="edit">
                                    <Glyphicon glyph="pencil" />
                                </Button>
                            </LinkContainer>
                            <Button bsSize="xsmall" className="delete" onClick={that.handleDelete(item.id)}>
                                verwijder
                            </Button>
                        </ButtonGroup>
                    </td>
                </tr>
            })
            this.setState({ groups: comps }); // Companies object
        })
    }
    componentWillMount() {
        this.getKennis("/api/companies/groups")
    }
    render() {

        return (
            <div>
                <LinkContainer to="/admin/leden/groepen/toevoegen">
                    <Button>
                        Groep toevoegen
                    </Button>
                </LinkContainer>
                <br /><br />
                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>groep naam</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.groups}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default GroepenOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Groepen/Overview.js